import React from 'react'
import Addcategory from '../../Components/admin/Addcategory'
function Category() {
  return (
    <div>
      <Addcategory/>
    </div>
  )
}

export default Category
